var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9206 2.14554e-08H1.04609C0.468287 0.000347331 -0.000115748 0.468982 2.14554e-08 1.04702V17.9216C0.000347331 18.4994 0.468982 18.9678 1.04702 18.9677H10.1321V11.6325H7.66857V8.76143H10.1321V6.64852C10.1321 4.19826 11.628 2.8646 13.8137 2.8646C14.8606 2.8646 15.7603 2.94263 16.0225 2.97747V5.53841H14.5153C13.3261 5.53841 13.0958 6.10348 13.0958 6.93285V8.76143H15.9391L15.5687 11.6325H13.0958V18.9677H17.9206C18.4988 18.9678 18.9675 18.4993 18.9677 17.9211C18.9677 17.921 18.9677 17.9209 18.9677 17.9206V1.04609C18.9674 0.468287 18.4987 -0.000115748 17.9206 2.14554e-08Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.8a451ecca3f53d1379e9ab1bf7761b30.svg";
export { ForwardRef as ReactComponent };